import { useState, useEffect } from "react";
import { MOBILE_WIDTH } from "../constants/SiteConstants";

const useMobileView = (minwidh = MOBILE_WIDTH) => {
  const [mobileView, setMobileView] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= minwidh) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return mobileView;
};

export default useMobileView;
